export default __webpack_public_path__ + "static/media/schools.67b0b0e3.svg";